export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14815.a088dc6b.jpg";